import { useCallback } from 'react';
import { useParam } from '@hooks/params/useParam';

export const useSelectedBundleId = (): [
  number | null,
  (bundleId: number | null) => void,
] => {
  const { value, setParam, removeParam } = useParam({ key: 'bundle' });

  const selectedBundleId = value ? Number(value) : null;

  const setSelectedBundleId = useCallback(
    (bundleId: number | null) => {
      if (bundleId === null) {
        removeParam();
        return;
      }

      setParam(String(bundleId));
    },
    [setParam, removeParam],
  );

  return [selectedBundleId, setSelectedBundleId];
};
